import { isNull } from "../../infra3d";
import { Scene as Canvas2dutilScene, Crosshair, Button } from "../utils";
import { FeatureStyle, GEOMETRYTYPE } from "../featuretree/internal";
import { USERINPUTTYPE } from "../userinput/internal";
import { ImageObservation, MeasureSequence, STREAMTYPE, } from "./internal";
/**
 * MultiViewMeasureSequence
 * @class MultiViewMeasureSequence
 * @author Benjamin Loesch
 */
export class MultiViewMeasureSequence extends MeasureSequence {
    constructor(scene, successcbf, failedcbf, mx, my) {
        super(scene, successcbf, failedcbf);
        // event variables
        this.mouseupeventnr = null;
        this.mousedowneventnr = null;
        this.mousemoveeventnr = null;
        this.geoframechangednmbr = null;
        this.geoframecollectionchangednmbr = null;
        this.ctrlkeydowneventnr = null;
        this.keyarrowdowneventnmbr = null;
        this.keyarrowupeventnmbr = null;
        this.keyarrowlefteventnmbr = null;
        this.keyarrowrighteventnmbr = null;
        this.keyc = null;
        this.keyctrleventnmbr = -1;
        this.keydeleteeventnmbr = null;
        this.doubleclkeventnr = null;
        this.mousewheeleventnmbr = null;
        this.featurecollection = null;
        this.pointfeature = null;
        this.pos = null;
        /**
         * @property {number} pointviewwidth width of the point view canvas
         * @default 300
         */
        this.pointviewwidth = 300;
        /**
         * @property {number} height of the point view canvas
         * @default 300
         */
        this.pointviewheight = 300;
        /**
         * @property {number} sequencestate
         * @default 0
         */
        this.sequencestate = 0;
        this.scene2d = null;
        /**
         * the start worker icon
         * @type {null}
         */
        this.workerstartbtn = null;
        /**
         * the currently selected crosshair -> visible in yellow
         * @type {null}
         */
        this.selectedelement = null;
        /**
         * an array of crosshairs for displaying the image observations
         * @type {Array}
         */
        this.posindicators = [];
        /**
         * important variable describes the actual index in posindicator array -> frame specific
         * @type {number}
         */
        this.actualidx = -1;
        /**
         * Array of observations
         * @type {Array}
         */
        this.imageobservations = [];
        this.epipolarlines = [];
        this.adjustedpos = null;
        /**
         * approximative value read by monoplotting
         */
        this.approxval = null;
        // animation variables and helpers
        this._t = 0;
        this._calcanimtimer = -1;
        this.engine = null;
        this.dragelement = null;
        this.lastcrosshair = null;
        this.multiviewmeasurepoint = null;
        this.pointviewcanvas = null;
        this.pointviewcanvasctx = null;
        this.panoroteventnr = -1;
        this.panozoomeventnr = -1;
        this._ctrlpressedcntr = 0;
        this.engine = this.scene.engine;
        //--- point preview canvas
        this.pointviewcanvas = document.createElement("canvas");
        this.pointviewcanvas.style.width = this.pointviewwidth + "px";
        this.pointviewcanvas.style.height = this.pointviewheight + "px";
        this.pointviewcanvas.oncontextmenu = function () {
            return false;
        };
        this.pointviewcanvas.width = this.pointviewwidth;
        this.pointviewcanvas.height = this.pointviewheight;
        this.pointviewcanvas.style.position = "absolute";
        this.pointviewcanvas.style.right = "0px";
        this.pointviewcanvas.style.top = "0px";
        this.pointviewcanvas.style.pointerEvents = "none";
        this.scene.engine.getCanvas().parentElement.appendChild(this.pointviewcanvas);
        this.pointviewcanvasctx = this.pointviewcanvas.getContext("2d");
        this.pointviewcanvasctx.fillRect(0, 0, this.pointviewcanvas.width, this.pointviewcanvas.height);
        this.pointviewcanvas.style.boxShadow = "0px 0px 11px 3px rgb(0, 0, 0)";
        this.hidePointView();
        this.scene2d = new Canvas2dutilScene(0, 0, this.scene.engine.getCanvas().width, this.scene.engine.getCanvas().height, this.scene.engine.getCanvas().parentElement);
        this.geoframecollection = this.scene.getCurrentGeoFrameCollection();
        this.geoframe = this.geoframecollection.getCurrentGeoFrame();
        this.startseqeunce();
        //create the calc button object
        //fake event
        const evt = { offsetX: mx, offsetY: my };
        this._onMouseDown(evt);
        //prepare a pointfeature to display the calculated solution
        this.featurecollection = this.scene.getFeatureHandler().createFeatureCollection(new FeatureStyle({
            stylename: "DrawStyle",
            rules: [
                {
                    filter: "",
                    symbolizer: "point",
                    params: {
                        "font-marker": {
                            name: "circle-o",
                        },
                        size: 20,
                        stroke: [1, 0, 0, 0.5],
                    },
                },
            ],
        }), null, "mmMultiPointMeasureSequence_internal", false);
        this.pointfeature = this.featurecollection.createFeature();
        this.pointfeature.geometry = this.pointfeature.createGeometry(GEOMETRYTYPE.POINT);
        this.pointfeature.hide();
        this.multiviewmeasurepoint = this.scene.getMeasureHandler().createMultiViewMeasurePoint(this.scene.getCurrentGeoframe(), (stats) => {
            this._onCalcUpdate(stats);
        }, (stats) => {
            this._onCalcResult(stats);
        });
    }
    /**
     * @method startseqeunce start the measure sequence - subscribe needed events etc.
     */
    startseqeunce() {
        //subscribe events
        this.mousedowneventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEDOWN, this._onMouseDown, this);
        this.mousemoveeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEMOVE, this._onMouseMove, this);
        this.mouseupeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEUP, this._onMouseUp, this);
        this.doubleclkeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.DOUBLECLICK, this._onDblClick, this);
        this.ctrlkeydowneventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ENTER, this._onEnterKey, this);
        this.keyc = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_C, this._onKeyC, this);
        this.geoframechangednmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this.geoframechanged, this);
        this.geoframecollectionchangednmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, this.geoframecollectionchanged, this);
        this.keyarrowlefteventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_LEFT, this._arrowleft, this);
        this.keyarrowrighteventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_RIGHT, this._arrowright, this);
        this.keyarrowupeventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_UP, this._arrowup, this);
        this.keyarrowdowneventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_ARROW_DOWN, this._arrowdown, this);
        this.mousewheeleventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.MOUSEWHEEL, this._onmousewheel, this);
        this.keydeleteeventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_DELETE, this._onkeydelete, this);
        this.keyctrleventnmbr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.KEY_CTRL_UP, this._onkeyctrl, this);
        this.scene.getCursorStyleHandler().setCursorStyle("crosshair");
        const geoframecollection = this.scene.getCurrentGeoFrameCollection();
        //check stream types and subscribe events
        if (geoframecollection.type == STREAMTYPE.STEREO) {
            geoframecollection.rightimagequadtree.onZoom = (d) => {
                this.updateIndicatorPosition();
            };
            geoframecollection.rightimagequadtree.onPan = (dx, dy) => {
                this.updateIndicatorPosition();
            };
        }
        else if (geoframecollection.type == STREAMTYPE.CALOTTE ||
            this.geoframecollection.type == STREAMTYPE.CUBEMAP) {
            this.panoroteventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.PANO_ROTATION, (lat, lon) => {
                this.updateIndicatorPosition();
            }, this);
            this.panozoomeventnr = this.scene.userInputHandler.subscribeEvent(USERINPUTTYPE.PANO_ZOOM, (lat, lon) => {
                this.updateIndicatorPosition();
            }, this);
        }
        else {
            //add events for panning or zooming
            geoframecollection.imagequadtree.onZoom = (d) => {
                this.updateIndicatorPosition();
            };
            geoframecollection.imagequadtree.onPan = (dx, dy) => {
                this.updateIndicatorPosition();
            };
        }
        this.sequencestate = 0;
    }
    _onmousewheel() {
        this.scene.infrascene.render();
        this.updateIndicatorPosition();
        window.setTimeout(() => {
            this.scene2d.render();
        }, 10);
    }
    /**
     * Start the Bündelblock-Worker
     */
    startWorker() {
        //callback for animation update
        const cb = () => {
            this.posindicators[this.actualidx].scale = 30 - (Math.cos(this._t / 250) / 2 + 1) * 10;
            this.posindicators[this.actualidx].scale = 30 - (Math.cos(this._t / 250) / 2 + 1) * 10;
            this.scene2d.render();
            this.scene.infrascene.render();
            this._t += 50;
        };
        this._calcanimtimer = window.setInterval(() => {
            cb();
        }, 10);
        this.multiviewmeasurepoint.imageobservations = [];
        //set all observations into measurepoint...
        for (let i = 0; i < this.imageobservations.length; i++) {
            if (!this.imageobservations[i].excludeForCalc) {
                this.multiviewmeasurepoint.imageobservations.push(this.imageobservations[i]);
            }
        }
        if (this.approxval) {
            this.multiviewmeasurepoint.calcCoordinates([
                this.approxval.Easting,
                this.approxval.Northing,
                this.approxval.Height,
            ]);
        }
        else {
            this.multiviewmeasurepoint.calcCoordinates();
        }
        this.selectedelement = null;
    }
    _onCalcUpdate(stats) {
        //not used...
    }
    _onCalcResult(stats) {
        window.clearInterval(this._calcanimtimer);
        this._calcanimtimer = -1;
        //get lowest pixelsize
        let min = Infinity;
        for (let i = 0; i < this.imageobservations.length; i++) {
            if (min > this.imageobservations[i].pixelsize * 0.001) {
                min = this.imageobservations[i].pixelsize * 0.001;
            }
        }
        const pixelacc = stats.m0 / min;
        //grün, wenn -> Restklaffe kleiner 3px im Bild mit der kleinsten Pixelsize
        if (pixelacc < 3.0) {
            this.pointfeature["geometry"]["coordinates"] = [
                [
                    this.multiviewmeasurepoint.Easting,
                    this.multiviewmeasurepoint.Northing,
                    this.multiviewmeasurepoint.Height,
                ],
            ];
            this.pointfeature.update(true);
            if (this.scene.multiviewprops.displayEstimationPoint)
                this.pointfeature.show();
            //update indicator appearance
            this._changeIndicatorBetweenRedGreen(1 / pixelacc);
            this.scene.viewer.getComponent("keyboard").activate();
        }
        else {
            this.pointfeature["geometry"]["coordinates"] = [
                [
                    this.multiviewmeasurepoint.Easting,
                    this.multiviewmeasurepoint.Northing,
                    this.multiviewmeasurepoint.Height,
                ],
            ];
            this.pointfeature.update(true);
            this.pointfeature.hide();
            //update indicator appearance
            this._changeIndicatorsToRed();
            this.scene.viewer.getComponent("keyboard").activate();
        }
        this.selectedelement = null;
    }
    _changeIndicatorBetweenRedGreen(val) {
        val = Math.max(0, val);
        val = Math.min(1, val);
        // 0 = red  :   0.5 = orange :   1 = green
        const r = (1 - val) * 255;
        const g = val * 255;
        const b = 0;
        for (let i = 0; i < this.posindicators.length; i++) {
            this.posindicators[i].changeColor("rgb(" + Math.round(r) + "," + Math.round(g) + "," + Math.round(b) + ")");
            this.posindicators[i].scale = 30;
            this.updateIndicatorPosition();
        }
        this.scene2d.render();
        this.scene.infrascene.render();
    }
    /**
     * Change all indicators to green -> this means calculation was ok!
     * @private
     */
    _changeIndicatorsToGreen() {
        for (let i = 0; i < this.posindicators.length; i++) {
            this.posindicators[i].changeColor("lightgreen");
            this.posindicators[i].scale = 30;
            this.updateIndicatorPosition();
        }
        this.scene2d.render();
        this.scene.infrascene.render();
    }
    /**
     * Change all indicators to red -> this means no convergence during calc
     * @private
     */
    _changeIndicatorsToRed() {
        for (let i = 0; i < this.posindicators.length; i++) {
            this.posindicators[i].changeColor("red");
            this.posindicators[i].scale = 30;
        }
        this.scene2d.render();
        this.scene.infrascene.render();
    }
    /**
     * Change all indicators to white -> this means no calculation was done yet
     * @private
     */
    _changeIndicatorsToWhite() {
        for (let i = 0; i < this.posindicators.length; i++) {
            this.posindicators[i].changeColor("white");
            this.posindicators[i].scale = 30;
        }
        this.scene2d.render();
        this.scene.infrascene.render();
    }
    /**
     * Hide all indicators
     * @private
     */
    _hideIndicators() {
        for (let i = 0; i < this.posindicators.length; i++) {
            this.posindicators[i].hide();
        }
        this.scene2d.render();
        this.scene.infrascene.render();
    }
    /**
     * Show all indicators...
     * @private
     */
    _showIndicators() {
        for (let i = 0; i < this.posindicators.length; i++) {
            this.posindicators[i].show();
        }
        this.scene2d.render();
        this.scene.infrascene.render();
    }
    destroy() {
        this.abortsequence();
    }
    /**
     *  @method reset resets the sequence to start a new measurement
     */
    reset() {
        this.hidePointView();
        this.scene.getCursorStyleHandler().setCursorStyle("crosshair");
        for (let i = 0; i < this.posindicators.length; i++) {
            this.scene2d.remove(this.posindicators[i]);
        }
        this.scene2d.remove(this.workerstartbtn);
        this.workerstartbtn = null;
        this.sequencestate = 0;
    }
    /**
     * @method _finishmeasurement
     * @private _finishmeasurement
     */
    _finishmeasurement() {
        this.scene.infrascene.traversalState.lockNavigation = false;
        this.pointfeature.hide();
        if (this.multiviewmeasurepoint.stats.convergence) {
            this.successcbf(this.multiviewmeasurepoint);
        }
        else {
            this.failedcbf("no convergence...");
        }
    }
    /**
     * @public abortsequence aborts the seqeunce, unsubscribes events
     */
    abortsequence() {
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEDOWN, this.mousedowneventnr);
        this.mousedowneventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEMOVE, this.mousemoveeventnr);
        this.mousemoveeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEUP, this.mouseupeventnr);
        this.mouseupeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ENTER, this.ctrlkeydowneventnr);
        this.ctrlkeydowneventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECHANGED, this.geoframechangednmbr);
        this.geoframechangednmbr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.GEOFRAMECOLLECTIONCHANGED, this.geoframecollectionchangednmbr);
        this.geoframecollectionchangednmbr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_LEFT, this.keyarrowlefteventnmbr);
        this.keyarrowlefteventnmbr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_RIGHT, this.keyarrowrighteventnmbr);
        this.keyarrowrighteventnmbr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_UP, this.keyarrowupeventnmbr);
        this.keyarrowupeventnmbr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_ARROW_DOWN, this.keyarrowdowneventnmbr);
        this.keyarrowdowneventnmbr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_C, this.keyc);
        this.keyc = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_C, this.doubleclkeventnr);
        this.doubleclkeventnr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.MOUSEWHEEL, this.mousewheeleventnmbr);
        this.mousewheeleventnmbr = null;
        this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.KEY_DELETE, this.keydeleteeventnmbr);
        this.keydeleteeventnmbr = null;
        const geoframecollection = this.scene.getCurrentGeoFrameCollection();
        if (geoframecollection.type == STREAMTYPE.STEREO) {
            geoframecollection.rightimagequadtree.onZoom = null;
            geoframecollection.rightimagequadtree.onPan = null;
        }
        else if (geoframecollection.type == STREAMTYPE.CALOTTE || geoframecollection.type == STREAMTYPE.CUBEMAP) {
            this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.PANO_ROTATION, this.panoroteventnr);
            this.scene.userInputHandler.unSubscribeEvent(USERINPUTTYPE.PANO_ZOOM, this.panozoomeventnr);
        }
        else {
            //Todo: Refactor this once Perspective GeoFrame collection is implemented.
            geoframecollection.imagequadtree.onZoom = null;
            geoframecollection.imagequadtree.onPan = null;
        }
        //todo: Refactor this once key-events are implemneted
        this.scene.viewer.getComponent("keyboard").activate();
        this.scene2d.destroy();
        this.scene.getFeatureHandler().removeFeatureCollection(this.featurecollection);
        this.reset();
    }
    //operations for geoframecollection and scene handling
    /**
     * updates actual geoframecollection
     * @method geoframecollectionchanged
     * @param geoframecollection
     */
    geoframecollectionchanged(geoframecollection) {
        this.geoframecollection = geoframecollection;
        this.scene.getCursorStyleHandler().setCursorStyle("crosshair");
    }
    /**
     * Updates the actual geoframe...
     * @method geoframechanged
     * @param geoframe
     */
    geoframechanged(geoframe) {
        this.geoframe = geoframe;
        this.dragelement = null;
        this.selectedelement = null;
        for (let i = 0; i < this.posindicators.length; i++) {
            this.posindicators[i].hide();
            this.epipolarlines[i].hide();
            this.scene2d.render();
        }
        //check if point is already set in this image
        this.actualidx = this._getActualIdx();
        //handle posindicator visiblity
        if (this.actualidx != -1) {
            if (!this.imageobservations[this.actualidx].excludeForCalc) {
                this.posindicators[this.actualidx].show();
            }
            this.scene2d.render();
        }
        //render epipolar-line
        if (this.pointfeature.ishidden && this.scene.multiviewprops.displayEpipolarLine) {
            this.epipolarlines[this.epipolarlines.length - 1].show();
        }
        this.updateIndicatorPosition();
        this.updateEpipolarLines();
    }
    //user interaction
    _arrowleft(evt) {
        if (!isNull(this.selectedelement)) {
            this.posindicators[this.actualidx].position.x -= 1;
            const mapinfo = this.scene
                .getMeasureHandler()
                .mouseToMap(this.posindicators[this.actualidx].position.x, this.posindicators[this.actualidx].position.y);
            const senscoords = this.scene.getMeasureHandler().mapToSensor(mapinfo[0].coords);
            this.imageobservations[this.actualidx].x = senscoords.x;
            this.imageobservations[this.actualidx].y = senscoords.y;
            this.imageobservations[this.actualidx].updateImageCoor();
            this.showPointView(this.posindicators[this.actualidx].position.x - this.pointviewwidth / 2, this.posindicators[this.actualidx].position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "");
            this.scene2d.render();
        }
    }
    _arrowright(evt) {
        if (!isNull(this.selectedelement)) {
            this.posindicators[this.actualidx].position.x += 1;
            const mapinfo = this.scene
                .getMeasureHandler()
                .mouseToMap(this.posindicators[this.actualidx].position.x, this.posindicators[this.actualidx].position.y);
            const senscoords = this.scene.getMeasureHandler().mapToSensor(mapinfo[0].coords);
            this.imageobservations[this.actualidx].x = senscoords.x;
            this.imageobservations[this.actualidx].y = senscoords.y;
            this.imageobservations[this.actualidx].updateImageCoor();
            this.showPointView(this.posindicators[this.actualidx].position.x - this.pointviewwidth / 2, this.posindicators[this.actualidx].position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "");
            this.scene2d.render();
        }
    }
    _arrowup(evt) {
        if (!isNull(this.selectedelement)) {
            this.posindicators[this.actualidx].position.y -= 1;
            const mapinfo = this.scene
                .getMeasureHandler()
                .mouseToMap(this.posindicators[this.actualidx].position.x, this.posindicators[this.actualidx].position.y);
            const senscoords = this.scene.getMeasureHandler().mapToSensor(mapinfo[0].coords);
            this.imageobservations[this.actualidx].x = senscoords.x;
            this.imageobservations[this.actualidx].y = senscoords.y;
            this.imageobservations[this.actualidx].updateImageCoor();
            this.showPointView(this.posindicators[this.actualidx].position.x - this.pointviewwidth / 2, this.posindicators[this.actualidx].position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "");
            this.scene2d.render();
        }
    }
    _arrowdown(evt) {
        if (!isNull(this.selectedelement)) {
            this.posindicators[this.actualidx].position.y += 1;
            const mapinfo = this.scene
                .getMeasureHandler()
                .mouseToMap(this.posindicators[this.actualidx].position.x, this.posindicators[this.actualidx].position.y);
            const senscoords = this.scene.getMeasureHandler().mapToSensor(mapinfo[0].coords);
            this.imageobservations[this.actualidx].x = senscoords.x;
            this.imageobservations[this.actualidx].y = senscoords.y;
            this.imageobservations[this.actualidx].updateImageCoor();
            this.showPointView(this.posindicators[this.actualidx].position.x - this.pointviewwidth / 2, this.posindicators[this.actualidx].position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "");
            this.scene2d.render();
        }
    }
    /**
     * Change left / right image when enter is pressed
     * @method _onEnterKey
     * @private
     */
    _onEnterKey() {
        this.startWorker();
    }
    /**
     * Change left / right image when enter is pressed
     * @method _onEnterKey
     * @private
     */
    _onKeyC() {
        if (this.actualidx > -1) {
            this.posindicators[this.actualidx].changeStyle();
            this.scene2d.render();
        }
    }
    _onkeydelete() {
        if (this.selectedelement != null) {
            this.imageobservations[this.actualidx].excludeForCalc = true;
            this.posindicators[this.actualidx].hide();
            this.selectedelement = null;
            this.scene.viewer.getComponent("keyboard").activate();
            this.scene2d.render();
            this.actualidx = -1;
            if (this.imageobservations.length > 1)
                this.startWorker();
        }
    }
    _onMouseDown(evt) {
        if (evt.button >= 1 || this.sequencestate == 9)
            return;
        const id = this.geoframe.dataPath;
        //check if point is already set in this image
        this.actualidx = this._getActualIdx();
        if (this.actualidx == -1) {
            //this means no point is set in this image
            this.sequencestate = 0;
        }
        else {
            //there is an existing point in this image
            this.sequencestate = 1;
        }
        if (this.sequencestate == 1 && this.imageobservations[this.actualidx].excludeForCalc) {
            //image observation was set and then deleted within the image
            this.sequencestate = 3;
        }
        switch (this.sequencestate) {
            case 0:
            case 3: {
                //create a new image observation
                const mapinfo = this.scene.getMeasureHandler().mouseToMap(evt.offsetX, evt.offsetY);
                const map = mapinfo[0].coords;
                const minfo = this.geoframe.getMeasureInfo();
                const senscoor = this.scene.getMeasureHandler().mapToSensor(map);
                let ck;
                if (minfo.streamtype == STREAMTYPE.CALOTTE) {
                    ck = minfo.sensors[mapinfo[0].sensorid].focallength;
                }
                else {
                    // PROJECTION.PERSPECTIVE -> Stereo Case : images are normaliced to normfocallength in processing
                    // Cubemap case. a normalized ck is used for each cubeface.
                    ck = minfo.imagemeta.focallength;
                }
                let io;
                if (minfo.streamtype == STREAMTYPE.CUBEMAP) {
                    io = new ImageObservation(this.geoframe, senscoor.x, senscoor.y, ck, id, mapinfo[0].sensorid, mapinfo[0].cubefaceorientation, mapinfo[0].cubefaceindex);
                }
                else {
                    io = new ImageObservation(this.geoframe, senscoor.x, senscoor.y, ck, id, mapinfo[0].sensorid);
                }
                //create or update an obeservation indicator
                this.lastcrosshair = this.scene2d.createCrosshair(evt.offsetX, evt.offsetY, 30);
                const line = this.scene2d.createLine(0, 0, 3, {});
                if (this.sequencestate == 3) {
                    this.imageobservations[this.actualidx] = io;
                    this.posindicators[this.actualidx] = this.lastcrosshair;
                    this.epipolarlines[this.actualidx] = line;
                }
                else {
                    //todo: need to check if observations from different segments are allowed or not.
                    if (this.imageobservations.length > 0) {
                        const segmentid = this.imageobservations[0].geoframe.segment;
                        const currentsegmentid = io.geoframe.segment;
                        if (segmentid !== currentsegmentid)
                            console.warn("observation from other segment added");
                    }
                    this.imageobservations.push(io);
                    this.posindicators.push(this.lastcrosshair);
                    this.epipolarlines.push(line);
                }
                this.actualidx = this.posindicators.length - 1;
                if (!(this.geoframecollection.type == STREAMTYPE.CALOTTE)) {
                    const mp = this.scene
                        .getMeasureHandler()
                        .createMonoplotMeasurePoint(this.geoframe, evt.offsetX, evt.offsetY, 20);
                    if (!mp.warning)
                        this.approxval = mp;
                }
                if (this.imageobservations.length > 1)
                    this.startWorker();
                this.showPointView(this.posindicators[this.actualidx].position.x - this.pointviewwidth / 2, this.posindicators[this.actualidx].position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "");
                break;
            }
            case 1: {
                //select the existing image observation
                const picked = this.scene2d.pick(evt.offsetX, evt.offsetY);
                this.lastdragpos = [evt.offsetX, evt.offsetY];
                if (picked instanceof Crosshair) {
                    this.dragelement = picked;
                }
                else if (picked instanceof Button) {
                    this.startWorker();
                }
                //check if an item was clicked on
                if (!isNull(this.dragelement)) {
                    this.selectedelement = this.dragelement;
                    this.selectedelement.changeColor("yellow");
                    this.scene.infrascene.traversalState.lockNavigation = true;
                    this.scene.viewer.getComponent("keyboard").deactivate();
                    this.scene.infrascene.render();
                }
                else {
                    //check release selected element
                    if (!isNull(this.selectedelement)) {
                        this._changeIndicatorsToWhite();
                        this.scene.viewer.getComponent("keyboard").activate();
                        this.selectedelement = null;
                        if (this.imageobservations.length > 1) {
                            this.startWorker();
                        }
                    }
                }
            }
        }
        this.scene2d.render();
    }
    _onMouseMove(evt) {
        if (this.sequencestate == 9)
            return;
        if (!isNull(this.dragelement)) {
            //dragging is on
            this.dragelement.position.x += evt.offsetX - this.lastdragpos[0];
            this.dragelement.position.y += evt.offsetY - this.lastdragpos[1];
            const mapinfo = this.scene
                .getMeasureHandler()
                .mouseToMap(this.posindicators[this.actualidx].position.x, this.posindicators[this.actualidx].position.y);
            const map = mapinfo[0].coords;
            //update the sensorid
            if (this.geoframecollection.type == STREAMTYPE.CUBEMAP) {
                this.imageobservations[this.actualidx].faceindex = mapinfo[0].cubefaceindex;
                this.imageobservations[this.actualidx].sensorid = mapinfo[0].sensorid;
            }
            else {
                this.imageobservations[this.actualidx].sensorid = mapinfo[0].sensorid;
            }
            const senscoor = this.scene.getMeasureHandler().mapToSensor(map);
            this.imageobservations[this.actualidx].setSensCoor(senscoor.x, senscoor.y);
            this.showPointView(this.posindicators[this.actualidx].position.x - this.pointviewwidth / 2, this.posindicators[this.actualidx].position.y - this.pointviewheight / 2, this.pointviewwidth, this.pointviewheight, "");
            this.lastdragpos = [evt.offsetX, evt.offsetY];
            this.scene2d.render();
            evt.stopPropagation();
            return;
        }
        else {
            this.updateIndicatorPosition();
        }
        this.scene2d.render();
    }
    _onMouseUp(evt) {
        if (this.sequencestate == 9 || evt.button > 0)
            return;
        if (evt.isDragging && !isNull(this.lastcrosshair)) {
            this.selectedelement = this.lastcrosshair;
            this._onkeydelete();
        }
        this.dragelement = null;
        this.lastcrosshair = null;
        this.scene.infrascene.traversalState.lockNavigation = false;
        this.scene.infrascene.render();
        this.updateIndicatorPosition();
    }
    /**
     * point calculation ok -> return found point
     * @private
     */
    _onDblClick() {
        if (this.sequencestate == 1) {
            this.sequencestate = 2;
            this._finishmeasurement();
        }
    }
    /**
     * determine the actual index by searching stream/framenumber tuple
     * @private
     */
    _getActualIdx() {
        const id = this.geoframe.dataPath;
        for (let i = 0; i < this.imageobservations.length; i++) {
            if (this.imageobservations[i].id == id) {
                return i;
            }
        }
        return -1;
    }
    /**
     * updates the left and right point according to pan or zoome imagequadtree
     * @private
     */
    updateIndicatorPosition() {
        if (this.actualidx > -1) {
            if (!this.imageobservations[this.actualidx])
                return;
            const imagemeta = this.geoframe.getMeasureInfo().imagemeta;
            const mapx = this.imageobservations[this.actualidx].x / (imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom));
            const mapy = this.imageobservations[this.actualidx].y / (imagemeta.tilesize * Math.pow(2, imagemeta.maxzoom));
            let mouse;
            if (this.geoframecollection.type == STREAMTYPE.CUBEMAP) {
                mouse = this.scene
                    .getMeasureHandler()
                    .mapToMouse(mapx, mapy, this.imageobservations[this.actualidx].faceindex);
            }
            else {
                mouse = this.scene
                    .getMeasureHandler()
                    .mapToMouse(mapx, mapy, this.imageobservations[this.actualidx].sensorid);
            }
            this.posindicators[this.actualidx].position.x = mouse.x;
            this.posindicators[this.actualidx].position.y = mouse.y;
        }
        this.updateEpipolarLines();
        this.scene2d.render();
    }
    /**
     * updates the epipolar line according to pan or zoom imagequadtree
     * @private
     */
    updateEpipolarLines() {
        if (!this.geoframecollection.hasloaded)
            return;
        let sensorid = 0;
        let faceorientation;
        let faceindex = 0;
        if (this.geoframecollection.imagequadtree) {
            sensorid = this.geoframecollection.imagequadtree.faceindex;
            faceindex = sensorid;
            if (this.geoframecollection.type == STREAMTYPE.CUBEMAP) {
                //todo: refactor this once other collection-types are implemented
                sensorid = this.geoframecollection.currentsensor;
                faceindex = this.geoframecollection.imagequadtree.faceindex;
                faceorientation = (this.geoframecollection.imagequadtree).faceToOrientation(faceindex);
            }
        }
        // update epipolar line offset changed by dragging or zooming
        for (let i = 0; i < this.epipolarlines.length; i++) {
            let linepoints;
            if (this.geoframecollection.type == STREAMTYPE.CUBEMAP) {
                linepoints = this.imageobservations[i].getEpipolarLine(this.geoframe, sensorid, faceorientation);
            }
            else {
                linepoints = this.imageobservations[i].getEpipolarLine(this.geoframe, sensorid);
            }
            //don't show epipolar line in image where the imageobservation was defined
            if (i == this.actualidx) {
                //this means we calc the epipolar line of the actual imageobesrvation
                this.epipolarlines[i].hide();
                return;
            }
            const map_p1 = this.scene.getMeasureHandler().sensorToMap(linepoints[0]);
            const map_p2 = this.scene.getMeasureHandler().sensorToMap(linepoints[1]);
            const mouse_p1 = this.scene.getMeasureHandler().mapToMouse(map_p1.x, map_p1.y, faceindex);
            const mouse_p2 = this.scene.getMeasureHandler().mapToMouse(map_p2.x, map_p2.y, faceindex);
            const m = (mouse_p1.y - mouse_p2.y) / (mouse_p1.x - mouse_p2.x);
            const q = mouse_p1.y - m * mouse_p1.x;
            //intersect line with y axis (x=0)
            mouse_p1.x = 0;
            mouse_p1.y = q;
            mouse_p2.x = this.scene.engine.getContextWidth();
            mouse_p2.y = this.scene.engine.getContextWidth() * m + q;
            this.epipolarlines[i].p1 = mouse_p1;
            this.epipolarlines[i].p2 = mouse_p2;
        }
    }
    // --- point preview handling
    /**
     * Hides the point preview window
     * @private
     */
    hidePointView() {
        this.pointviewcanvas.style.visibility = "hidden";
    }
    /**
     * shows the point preview window with a screenshot from actual view
     * @param ulx
     * @param uly
     * @param w
     * @param h
     * @param label
     */
    showPointView(ulx, uly, w, h, label) {
        if (this.actualidx != 0)
            return;
        this.scene.infrascene.render();
        const arr = this.engine.getImageBuffer(ulx, uly, w, h);
        const image = this.pointviewcanvasctx.createImageData(w, h);
        for (let i = 0; i < arr.length; i++) {
            image.data[i] = arr[i];
        }
        this.pointviewcanvasctx.putImageData(image, 0, 0);
        this.pointviewcanvasctx.lineWidth = 2;
        const ctx = this.pointviewcanvasctx;
        ctx.lineWidth = 1;
        ctx.strokeStyle = "rgba(0,0,0,0.3)";
        ctx.beginPath();
        ctx.moveTo(w / 2, h / 4);
        ctx.lineTo(w / 2, (3 * h) / 4);
        ctx.moveTo(w / 4, h / 2);
        ctx.lineTo((3 * w) / 4, h / 2);
        ctx.stroke();
        ctx.shadowColor = "black";
        ctx.shadowOffsetX = 0;
        ctx.shadowOffsetY = 0;
        ctx.shadowBlur = 1;
        ctx.lineWidth = 1;
        ctx.font = "34px Verdana";
        ctx.fillStyle = "white";
        ctx.fillText(label, 25, 35);
        ctx.strokeStyle = "black";
        ctx.strokeText(label, 25, 35);
        this.pointviewcanvas.style.visibility = "visible";
    }
    _onkeyctrl() {
        // ctrl pressed show/hide epipolar line
        this._ctrlpressedcntr += 1;
        this._ctrlpressedcntr %= 3;
        switch (this._ctrlpressedcntr) {
            case 0:
                // standard
                this.pointfeature.show();
                break;
            case 1:
                // show epipolar line
                if (this.geoframe.getMeasureInfo().projection != 1) {
                    this.pointfeature.hide();
                    this.epipolarlines[this.epipolarlines.length - 1].show();
                    this.scene2d.render();
                }
                break;
            case 2:
                // hide everything
                this.epipolarlines[this.epipolarlines.length - 1].hide();
                this.pointfeature.hide();
                this.scene2d.render();
                break;
        }
    }
}
//# sourceMappingURL=multiviewmeasuresequence.js.map